// extracted by mini-css-extract-plugin
export default {"dialog":"PaymentCompleteDialog_dialog__gPloH","icon":"PaymentCompleteDialog_icon__5JxCl","formButton":"PaymentCompleteDialog_formButton__DuUSX"};